<template>
  <div class="d-lg-none">
    <nav class="app-bottom-nav" aria-label="Hauptnavigation">
      <router-link v-for="item in primaryItems" :key="item.name" class="bottom-nav-item" :class="{ active: isActive(item) }" :to="item.to">
        <font-awesome-icon :icon="item.icon" />
        <span>{{ item.label }}</span>
      </router-link>
      <button type="button" class="bottom-nav-item" :class="{ active: moreActive }" aria-controls="more-menu"
        :aria-expanded="moreOpen ? 'true' : 'false'" @click="moreOpen = true">
        <font-awesome-icon icon="bars" />
        <span>Mehr</span>
      </button>
    </nav>

    <div id="more-menu" class="offcanvas offcanvas-bottom h-auto rounded-top-4" :class="{ show: moreOpen }"
      tabindex="-1" aria-labelledby="more-menu-title" :aria-hidden="moreOpen ? 'false' : 'true'">
      <div class="offcanvas-header">
        <h2 id="more-menu-title" class="h5 mb-0">Alle Bereiche</h2>
        <button type="button" class="btn-close" aria-label="Schließen" @click="moreOpen = false"></button>
      </div>
      <div class="offcanvas-body pt-0 pb-4 d-flex flex-column gap-3">
        <div v-for="group in groups" :key="group.title" class="d-flex flex-column gap-1">
          <span v-if="group.title" class="nav-group-label">{{ group.title }}</span>
          <router-link v-for="item in group.entries" :key="item.name" class="side-link" :class="{ active: isActive(item) }" :to="item.to"
            @click="moreOpen = false">
            <font-awesome-icon class="side-link-icon" :icon="item.icon" />
            <span>{{ item.title }}</span>
          </router-link>
        </div>
      </div>
    </div>
    <div v-if="moreOpen" class="offcanvas-backdrop fade show" @click="moreOpen = false"></div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useNavigation } from "@/composables/useNavigation";

defineOptions({ name: "BottomNav" });

// Short labels for the tab bar; everything else is reachable through "Mehr".
const PRIMARY_TABS = [
  { name: "Dashboard", label: "Start" },
  { name: "Ausfahrten", label: "Ausfahrten" },
  { name: "Mitglieder", label: "Mitglieder" },
];

const route = useRoute();
const { groups, findByName, isActive } = useNavigation();
const moreOpen = ref(false);

const primaryItems = computed(() =>
  PRIMARY_TABS.map((tab) => {
    const item = findByName(tab.name);
    return item ? { ...item, label: tab.label } : null;
  }).filter(Boolean)
);

const moreActive = computed(() => {
  const topLevelName = route.matched[0]?.name;
  return !PRIMARY_TABS.some((tab) => tab.name === topLevelName);
});

watch(
  () => route.fullPath,
  () => {
    moreOpen.value = false;
  }
);
</script>
